export enum MenuItemType {
  RouterLink,
  Link,
  Command,
  More,
}
